import { render, staticRenderFns } from "./BlogAdd.vue?vue&type=template&id=8dfcc380&scoped=true&"
import script from "./BlogAdd.vue?vue&type=script&lang=js&"
export * from "./BlogAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfcc380",
  null
  
)

export default component.exports